// extracted by mini-css-extract-plugin
export default {"slider":"slider_slider__NEU+n","container":"slider_container__NfJZz","overlay":"slider_overlay__gkhSR","image1":"slider_image1__CXKDR","image2":"slider_image2__Bz1tM"};